import HorizontalScrollableContainer from "../Common/HorizontalScrollIContainer";
import { SpotifyLyricInfo } from "../WeddingInfo/WeddingInfo";

interface SpotifyLyricProps {
  lyricInfos: SpotifyLyricInfo[];
  title: string;
}

const SpotifyLyric: React.FC<SpotifyLyricProps> = ({ lyricInfos, title }) => {
  return (
    <div className="flex flex-col text-black mt-4">
      <div className="text-white font-bold text-left ml-4">{title}</div>

      <HorizontalScrollableContainer>
        <div className="text-sm leading-relaxed text-gray-700">
          <div className="flex space-x-4">
            {lyricInfos.map((lyric, lyricIdx) => {
              const lines = lyric.message.trim().split("\n");

              return (
                <div
                  key={lyricIdx}
                  className={`${lyric.color} w-64 mb-4 rounded-lg text-black/50 text-left font-bold px-4 py-8 rounded-lg`}
                >
                  {lines.map((line, index) => {
                    const isHighlighted = lyric.hightlightLines.includes(index);
                    return (
                      <span
                        key={index}
                        className={isHighlighted ? "text-white" : ""}
                      >
                        {line.trim()}
                        <br />
                      </span>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      </HorizontalScrollableContainer>
    </div>
  );
};

export default SpotifyLyric;
